// extracted by mini-css-extract-plugin
export default {"container":"ProfileInfo_container__CHSKI"};